//
//
//
//
//
//
//
//
//
//

import './css/index.css'
export default {
  data(){
    return{
      startDate:'',
      endDate:'',
    }
  },
  methods:{
    search(){
      this.$emit('notice-search',this.startDate,this.endDate)
    },
    init(startDate,endDate){
      this.startDate = startDate
      this.endDate = endDate
    },
    selectStartDate(){
      let _this = this
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD',
        yearRow:"{value}年",
        monthRow:"{value}月",
        dayRow:"{value}日",
        minYear:2000,
        maxYear:2050,
        value: this.startDate,
        onConfirm (value) {
          _this.startDate = value
        }
      })
    },
    selectEndDate(){
      let _this = this
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM-DD',
        yearRow:"{value}年",
        monthRow:"{value}月",
        dayRow:"{value}日",
        minYear:2000,
        maxYear:2050,
        value: this.endDate,
        onConfirm (value) {
          _this.endDate = value
        }
      })
    }
  },
  mounted(){
    
  }
}



// WEBPACK FOOTER //
// ./src/components/dateRangeSearch/index.vue